import { useApi } from "./useApi";
import { useAuth } from "./useAuth";

interface HolidayInfo {
  active: boolean;
  endsAt: string | null;
  source: "admin" | "client" | null;
}

/**
 * Hook to check holiday status for the current user.
 * Piggybacks on the profile API to avoid extra network calls.
 */
export function useHoliday(): HolidayInfo & { loading: boolean } {
  const { jwt, role } = useAuth();

  const url = role === "admin"
    ? `/api/admin/${jwt}/profile`
    : role === "client"
      ? `/api/client/${jwt}/profile`
      : null;

  const { data, loading } = useApi<Record<string, unknown>>(url);

  if (!data) return { active: false, endsAt: null, source: null, loading };

  if (role === "admin") {
    return {
      active: data.holiday_mode === true,
      endsAt: (data.holiday_ends_at as string) || null,
      source: data.holiday_mode ? "admin" : null,
      loading,
    };
  }

  if (role === "client") {
    const adminHoliday = data.adminHoliday === true;
    const clientHoliday = data.active === true;
    return {
      active: adminHoliday || clientHoliday,
      endsAt: adminHoliday
        ? (data.adminEndsAt as string) || null
        : (data.endsAt as string) || null,
      source: adminHoliday ? "admin" : clientHoliday ? "client" : null,
      loading,
    };
  }

  return { active: false, endsAt: null, source: null, loading };
}
